import {
  ConsultaSeguimentoPergunta01ExemplosEnum,
  ConsultaSeguimentoPergunta01Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-01/model-consultaSeguimentoPergunta01'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum, SimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { convertToPassouFalhou, HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta01Model {
  header: MchatRfAplicacaoQueryModel
  exemplosPassou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  exemplosFalhou: ReadonlyArray<MchatRfAplicacaoQueryModel>
  perguntaMaiorFrequencia: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta01Model
}

export const convertAplicacaoPergunta01 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta01Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_01_01)
  const perguntaMaiorFrequencia = aplicacoes.find(
    (aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_01_09
  )
  const exemplosPassou = aplicacoes.filter((aplicacao) => PERGUNTA_01_EXEMPLOS_PASSOU.includes(aplicacao.pergunta))
  const exemplosFalhou = aplicacoes.filter((aplicacao) => PERGUNTA_01_EXEMPLOS_FALHOU.includes(aplicacao.pergunta))

  if (header == undefined) return null

  return {
    header,
    exemplosPassou,
    exemplosFalhou,
    perguntaMaiorFrequencia,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_01_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_01_EXEMPLOS: {
        PASSOU: convertAplicacoesToExemplos(exemplosPassou),
        FALHOU: convertAplicacoesToExemplos(exemplosFalhou),
      },
      PERGUNTA_01_MAIOR_FREQUENCIA: convertToPassouFalhou(perguntaMaiorFrequencia?.stPassou),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta01ExemplosEnum, SimNaoEnum | undefined> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta01ExemplosEnum, SimNaoEnum | undefined>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const PERGUNTA_01_EXEMPLOS_PASSOU = [
  MChatPerguntaEnum.PERGUNTA_01_02,
  MChatPerguntaEnum.PERGUNTA_01_03,
  MChatPerguntaEnum.PERGUNTA_01_04,
  MChatPerguntaEnum.PERGUNTA_01_05,
]

const PERGUNTA_01_EXEMPLOS_FALHOU = [
  MChatPerguntaEnum.PERGUNTA_01_06,
  MChatPerguntaEnum.PERGUNTA_01_07,
  MChatPerguntaEnum.PERGUNTA_01_08,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta01ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_PARA_OBJETO]: undefined,
  [ConsultaSeguimentoPergunta01ExemplosEnum.APONTA_PARA_OBJETO]: undefined,
  [ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_E_COMENTA_SOBRE_OBJETO]: undefined,
  [ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_QUANDO_GENITOR_APONTA]: undefined,
  [ConsultaSeguimentoPergunta01ExemplosEnum.IGNORA_VOCE]: undefined,
  [ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_AO_REDOR]: undefined,
  [ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_PARA_DEDO_DO_GENITOR]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta01ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_01_02]: ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_PARA_OBJETO,
  [MChatPerguntaEnum.PERGUNTA_01_03]: ConsultaSeguimentoPergunta01ExemplosEnum.APONTA_PARA_OBJETO,
  [MChatPerguntaEnum.PERGUNTA_01_04]: ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_E_COMENTA_SOBRE_OBJETO,
  [MChatPerguntaEnum.PERGUNTA_01_05]: ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_QUANDO_GENITOR_APONTA,
  [MChatPerguntaEnum.PERGUNTA_01_06]: ConsultaSeguimentoPergunta01ExemplosEnum.IGNORA_VOCE,
  [MChatPerguntaEnum.PERGUNTA_01_07]: ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_AO_REDOR,
  [MChatPerguntaEnum.PERGUNTA_01_08]: ConsultaSeguimentoPergunta01ExemplosEnum.OLHA_PARA_DEDO_DO_GENITOR,
}
